const appKey = "fusion2021tour"
const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}`,
  appInfo: {
    name: "GFusion Tour 来了",
    description: "欢迎大家来玩",
    shareTitle: "GFusion Tour 来了",
    shareDescription: "欢迎大家来玩",
  },
  links: {
    buy: "https://detail.damai.cn/item.htm?id=654817777616",
    volunteer: "http://sparkidea.mikecrm.com/5x2Q057",
    topic: "https://www.gcores.com/topics/9",
  },
  linksGz: {
    buy: "https://show.bilibili.com/platform/detail.html?id=53700",
    volunteer: "http://sparkidea.mikecrm.com/DK3LNqT",
    topic: "https://www.gcores.com/topics/9",
  },
}
